import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FormDialog from './FormDialog';
import ClientProvider from './client';
export default createDemo(import.meta.url, FormDialog, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/dialogs/demos/form/FormDialog.tsx",
    "fileName": "FormDialog.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Button from '@mui/material/Button';\nimport TextField from '@mui/material/TextField';\nimport Dialog from '@mui/material/Dialog';\nimport DialogActions from '@mui/material/DialogActions';\nimport DialogContent from '@mui/material/DialogContent';\nimport DialogContentText from '@mui/material/DialogContentText';\nimport DialogTitle from '@mui/material/DialogTitle';\n\nexport default function FormDialog() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [open, setOpen] = React.useState(false);\n\n  const handleClickOpen = () => {\n    setOpen(true);\n  };\n\n  const handleClose = () => {\n    setOpen(false);\n  };\n\n  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {\n    event.preventDefault();\n    const formData = new FormData(event.currentTarget);\n    const formJson = Object.fromEntries((formData as any).entries());\n    const email = formJson.email;\n    console.log(email);\n    handleClose();\n  };\n\n  return (\n    <React.Fragment>\n      <Button variant=\"outlined\" onClick={handleClickOpen}>\n        Open form dialog\n      </Button>\n      <Dialog open={open} onClose={handleClose}>\n        <DialogTitle>Subscribe</DialogTitle>\n        <DialogContent>\n          <DialogContentText>\n            To subscribe to this website, please enter your email address here. We\n            will send updates occasionally.\n          </DialogContentText>\n          <form onSubmit={handleSubmit} id=\"subscription-form\">\n            <TextField\n              autoFocus\n              required\n              margin=\"dense\"\n              id=\"name\"\n              name=\"email\"\n              label=\"Email Address\"\n              type=\"email\"\n              fullWidth\n              variant=\"standard\"\n            />\n          </form>\n        </DialogContent>\n        <DialogActions>\n          <Button onClick={handleClose}>Cancel</Button>\n          <Button type=\"submit\" form=\"subscription-form\">\n            Subscribe\n          </Button>\n        </DialogActions>\n      </Dialog>\n    </React.Fragment>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 65,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Button from '@mui/material/Button';\nimport TextField from '@mui/material/TextField';\nimport Dialog from '@mui/material/Dialog';\nimport DialogActions from '@mui/material/DialogActions';\nimport DialogContent from '@mui/material/DialogContent';\nimport DialogContentText from '@mui/material/DialogContentText';\nimport DialogTitle from '@mui/material/DialogTitle';\n\nexport default function FormDialog() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [open, setOpen] = React.useState(false);\n\n  const handleClickOpen = () => {\n    setOpen(true);\n  };\n\n  const handleClose = () => {\n    setOpen(false);\n  };\n\n  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {\n    event.preventDefault();\n    const formData = new FormData(event.currentTarget);\n    const formJson = Object.fromEntries((formData as any).entries());\n    const email = formJson.email;\n    console.log(email);\n    handleClose();\n  };\n\n  return (\n    <React.Fragment>\n      <Button variant=\"outlined\" onClick={handleClickOpen}>\n        Open form dialog\n      </Button>\n      <Dialog open={open} onClose={handleClose}>\n        <DialogTitle>Subscribe</DialogTitle>\n        <DialogContent>\n          <DialogContentText>\n            To subscribe to this website, please enter your email address here. We\n            will send updates occasionally.\n          </DialogContentText>\n          <form onSubmit={handleSubmit} id=\"subscription-form\">\n            <TextField\n              autoFocus\n              required\n              margin=\"dense\"\n              id=\"name\"\n              name=\"email\"\n              label=\"Email Address\"\n              type=\"email\"\n              fullWidth\n              variant=\"standard\"\n            />\n          </form>\n        </DialogContent>\n        <DialogActions>\n          <Button onClick={handleClose}>Cancel</Button>\n          <Button type=\"submit\" form=\"subscription-form\">\n            Subscribe\n          </Button>\n        </DialogActions>\n      </Dialog>\n    </React.Fragment>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 65,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Button",
      "@mui/material/TextField",
      "@mui/material/Dialog",
      "@mui/material/DialogActions",
      "@mui/material/DialogContent",
      "@mui/material/DialogContentText",
      "@mui/material/DialogTitle"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
